import { Col, Row, Typography, Spin, Flex } from "antd";
import { useIntl } from "react-intl";
import { UploadImageForm } from "~components/Images";
import { ImageTypes } from "~enums/imageTypes";
import { ImageBaseTypes } from "~enums/imageBaseTypes";
import { useFetchSeason } from "../../entities/api";
import EditSeasonForm from "./EditSeasonForm";
import EditSeasonFormWrapper from "./EditSeasonFormWrapper";
import { PromotionRelegationRules } from "~Features/EditSeason/components/PromotionRelegationRules/PromotionRelegationRules";
import { useSportConfiguration } from "~hooks/useSportConfiguration.js";
import {PermissionNames} from "~enums/permissions.ts";
import { useInvalidateCache } from "~hooks/useInvalidateCache.ts";

const EditSeason = () => {
  const { formatMessage } = useIntl();
  const { data: current, isLoading } = useFetchSeason({
    include: "organizations,fixtures,entities,fixtureProfiles,standingConfigurations,leaderCriteria",
  });

  const {
    uiConfiguration
  } = useSportConfiguration();
  const { seasonUpsert: seasonUpsertUiConfiguration } = uiConfiguration.pages;

  const { mutateAsync: invalidateCache } = useInvalidateCache();
  const onImageUploadSuccess = () => {
    invalidateCache()
  }

  return (
    <>
      {isLoading && <Flex justify="center" style={{ marginTop: "4em" }}><Spin size="default" /></Flex>}
      {current && (
        <>
          <Typography.Title level={4}>
            {formatMessage({
              id: "season.update",
              defaultMessage: "Update Season",
            })}
          </Typography.Title>
          <Row>
            <Col span={18}>
              {current && (
                <EditSeasonFormWrapper seasonData={current}>
                  <EditSeasonForm reloadData={() => {}} />
                </EditSeasonFormWrapper>
              )}
            </Col>
            <Col span={6}>
              <UploadImageForm
                imageType={ImageTypes.Logo}
                baseId={current?.data?.[0]?.seasonId}
                images={current?.data?.[0]?.images}
                baseType={ImageBaseTypes.Season}
                permissionKey={PermissionNames.SEASON}
                onSuccess={onImageUploadSuccess}
              />
              {seasonUpsertUiConfiguration.promotionRelegationRules.enabled && (
                <PromotionRelegationRules season={current?.data?.[0]} />
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default EditSeason;
